import { render, staticRenderFns } from "./DownloadVideoButton.vue?vue&type=template&id=5b9f86f1&scoped=true"
import script from "./DownloadVideoButton.vue?vue&type=script&lang=js"
export * from "./DownloadVideoButton.vue?vue&type=script&lang=js"
import style0 from "./DownloadVideoButton.vue?vue&type=style&index=0&id=5b9f86f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f86f1",
  null
  
)

export default component.exports